import { VehicleMonitoringMapData } from '@modules/vehicle-monitoring/types/models';

export const VEHICLE_MONITORING_MAP_NO_DATA: VehicleMonitoringMapData = { polyline: [], marker: [] };
